/**
 * b2c-pricing.js — Artline Group EU
 * B2C (retail) only: price update on variant change + gift banner.
 * Unit price is static inside variant tabs (variant-button.liquid).
 */

(function ArtlineB2C() {
  'use strict';

  if (document.body.getAttribute('data-b2b') === 'true') return;

  var HIDDEN_VARIANTS = ['150 g', '300 g', '600 g'];
  var GIFT_TEXT = 'Add 2 free pigments from your cart before checkout';
  var giftBanner = null;

  // ─── Money formatting ────────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      var fmt = (window.theme.settings && window.theme.settings.moneyFormat) || '&euro;{{amount}}';
      return window.theme.Currency.formatMoney(cents, fmt);
    }
    // Fallback: format as euro with comma decimal
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20ac' + amount;
  }

  // ─── Price update ─────────────────────────────────────────────────────────────
  function updateRetailPrice(variant) {
    var block = document.querySelector('[data-retail-price-block]');
    if (!block) return;

    var price = variant.price;
    var compareAt = variant.compare_at_price;
    var hasDiscount = compareAt && compareAt > price;

    var row = block.querySelector('.artline-price__row');
    if (!row) return;

    if (hasDiscount) {
      var savedCents = compareAt - price;
      var savedMoney = formatMoney(savedCents);
      row.innerHTML =
        '<span class="artline-price__main artline-price__main--sale">' + formatMoney(price) + '</span>' +
        '<span class="artline-price__compare">' + formatMoney(compareAt) + '</span>' +
        '<span class="artline-price__save">Save ' + savedMoney + '</span>';
    } else {
      row.innerHTML =
        '<span class="artline-price__main">' + formatMoney(price) + '</span>';
    }
  }

  // ─── Gift banner ──────────────────────────────────────────────────────────────
  function updateGiftVisibility(option1, option2, option3) {
    if (!giftBanner) return;
    var title = (option1 || '') + ' ' + (option2 || '') + ' ' + (option3 || '');
    var hide = HIDDEN_VARIANTS.some(function(v) { return title.indexOf(v) >= 0; });
    giftBanner.style.display = hide ? 'none' : '';
  }

  function buildGiftBanner(imgSrc) {
    var slot = document.getElementById('artline-gift-slot');
    if (!slot || giftBanner) return;
    var banner = document.createElement('div');
    banner.id = 'artline-gift-banner';
    banner.innerHTML =
      (imgSrc ? '<img src="' + imgSrc + '" alt="" width="28" height="28">' : '') +
      '<span>' + GIFT_TEXT + '</span>';
    slot.appendChild(banner);
    giftBanner = banner;
    var radios = document.querySelectorAll('input[data-variant-input]:checked');
    var parts = [];
    radios.forEach(function(r) { if (r.value) parts.push(r.value); });
    var hide = HIDDEN_VARIANTS.some(function(v) { return parts.join(' ').indexOf(v) >= 0; });
    giftBanner.style.display = hide ? 'none' : '';
  }

  function initGiftBanner() {
    function grabAndBuild() {
      var orig = document.getElementById('free-gift-badge');
      var imgSrc = '';
      if (orig) {
        var img = orig.querySelector('img');
        if (img) imgSrc = img.src;
        orig.parentNode && orig.parentNode.removeChild(orig);
      }
      buildGiftBanner(imgSrc);
    }
    if (document.getElementById('free-gift-badge')) {
      grabAndBuild();
    } else {
      var obs = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          m.addedNodes.forEach(function(node) {
            if (!node || node.nodeType !== 1) return;
            if (node.id === 'free-gift-badge' || (node.querySelector && node.querySelector('#free-gift-badge'))) {
              obs.disconnect();
              setTimeout(grabAndBuild, 50);
            }
          });
        });
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  // ─── Variant change ───────────────────────────────────────────────────────────
  function onVariantChange(variant) {
    if (!variant) return;
    updateRetailPrice(variant);
    updateGiftVisibility(variant.option1, variant.option2, variant.option3);
  }

  function init() {
    initGiftBanner();
  }

  // ─── Listeners ───────────────────────────────────────────────────────────────
  function bindListeners() {
    document.addEventListener('variant:change', function(e) {
      onVariantChange(e.detail && e.detail.variant);
    });
    document.addEventListener('variantChange', function(e) {
      onVariantChange(e.detail && e.detail.variant);
    });
  }

  // ─── Boot ────────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); bindListeners(); });
  } else {
    init();
    bindListeners();
  }
  document.addEventListener('shopify:section:load', init);

  window.ArtlineB2C = { init: init, onVariantChange: onVariantChange };
})();
